import { defineComponent as _defineComponent } from 'vue'
import { useElementSize, useLocalStorage } from '@vueuse/core'
import { onMounted, ref, watch } from 'vue'
import Button from '../../../components/ui/button/Button.vue'
import Collapsible from '../../../components/ui/collapsible/Collapsible.vue'
import Mapa from '../../../components/ui/mapa/Mapa.vue'
import { usePlanejamentoOrdemServico } from '../../../composables/usePlanejamentoOrdemServico'
import LayoutMap from '../../../layouts/LayoutMap.vue'
import CardFinalizacao from './CardFinalizacao.vue'
import FormPlanejamentoOrdemServico from './FormPlanejamentoOrdemServico.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PlanejarOrdemServico',
  setup(__props) {

const collapsible = ref(null)
const storageRecuo = useLocalStorage('storageRecuo', 0)
const {
	ordemServico,
	getPlanejamentoOrdemServico,
	geojson,
	lancarParcelas,
	parcelasGeradas,
	limparPlanejamento,
} = usePlanejamentoOrdemServico()

const { width } = useElementSize(collapsible)
watch(width, () => {
	storageRecuo.value = ((width.value - 15) / window.innerWidth) * 100
})

onMounted(() => {
	getPlanejamentoOrdemServico()
})

return { __sfc: true,collapsible, storageRecuo, ordemServico, getPlanejamentoOrdemServico, geojson, lancarParcelas, parcelasGeradas, limparPlanejamento, width, Button, Collapsible, Mapa, LayoutMap, CardFinalizacao, FormPlanejamentoOrdemServico }
}

})